import { getContextualThemeForModule } from "../contextualTheme";

const scales = getContextualThemeForModule("scales");

/** Tema del hub / estudio de escalas — canvas Serenity + acento rojo pedagógico. */
export const SCALE_HUB_THEME = {
  bg: "#1c1a19",
  bgElevated: "#242220",
  bgCard: "#2a2826",
  bgCardHover: "#32302e",
  border: "rgba(245, 240, 235, 0.08)",
  borderHover: "rgba(245, 240, 235, 0.15)",
  textMain: "#f5f0eb",
  textMuted: "#a09890",
  textDim: "#6a635c",
  accent: scales.accent,
  accentHover: scales.accentHover,
  accentGlow: "rgba(255, 77, 77, 0.28)",
  accentSoft: "rgba(255, 77, 77, 0.12)",
} as const;
